'use client'

import { useDismissibleWidget } from '@/hooks/use-dismissible-widget'
import { WIDGET_DISMISSED_KEY } from '@/lib/constants'
import { APP_LINKS } from '@/lib/constants/app-links'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import { CloseIcon } from '../icons/CloseIcon'
import { TeamPayIconDark } from '../icons/TeamPayIconDark'
import { Button } from '../ui/button'

export function DownloadAppWidget() {
  const { isVisible, dismiss } = useDismissibleWidget({
    storageKey: WIDGET_DISMISSED_KEY
  })

  const t = useTranslations('DownloadAppWidget')

  // Add/remove body padding based on widget visibility
  useEffect(() => {
    if (isVisible) {
      document.body.classList.add('pb-16', 'md:pb-0')
    } else {
      document.body.classList.remove('pb-16', 'md:pb-0')
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('pb-16', 'md:pb-0')
    }
  }, [isVisible])

  const handleDownload = () => {
    dismiss()
    window.open(APP_LINKS.home, '_blank')
  }

  if (!isVisible) {
    return null
  }

  return (
    <div className="fixed right-0 bottom-0 z-40 flex w-full flex-col items-center justify-center gap-4 bg-[#131313] md:hidden">
      <div className="relative flex w-full justify-center px-6 py-6">
        <Button
          icon={<TeamPayIconDark />}
          iconPosition="left"
          onClick={handleDownload}
          className="text-primary-500 mx-auto inline-flex bg-white px-8"
          label={t('buttonText')}
        />

        <Button
          variant="ghost"
          icon={<CloseIcon className="text-white" size="24px" />}
          className="absolute top-1 right-1"
          onClick={dismiss}
        />
      </div>
    </div>
  )
}
